import { useMutation } from "@tanstack/react-query";

import ReportsServices from "@/services/ReportsService";

import { promiseToast } from "@/modules/index";
import { downloadBlob } from "@/utils";

/** A saved report's PDF, downloaded under the name the API gives it. */
export const useReportDownload = () => {
	const mutation = useMutation({
		mutationFn: (id: number) => ReportsServices.generateById(id),
		onSuccess: (response) => {
			const disposition = response.headers["content-disposition"];
			const match = disposition?.match(/filename="(.+)"/);
			const fileName = match?.[1] ?? "report.pdf";
			downloadBlob(response.data, fileName);
		},
	});

	return {
		download: (id: number) => promiseToast(mutation.mutateAsync(id)),
		isPending: mutation.isPending,
	};
};
